<template>
  <div id="pga">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <div class="box">
          <h3 :style="cssProps">{{ $t("titles.modality") }}</h3>

          <!-- CAMPUS -->
          <div class="item">
            <label>
              {{ $t("titles.pga_modality") }} <span class="obligatory">*</span>
            </label>
            <span>{{ $t("descriptions.pga") }}</span>
            <v-radio-group v-model="person.edition" class="shadow">
              <v-radio
                v-for="(value, key) in campus_types"
                :value="key"
                :key="key"
                @change="
                  brotherDiscount();
                  calculatePrice();
                "
              >
                <template v-slot:label>
                  <span :class="error.person.edition ? 'obligatory' : ''">
                    {{ $t(value.type) }}
                    {{
                      ["campus.pga_minibasket"].includes(value.type)
                        ? $t("descriptions.intern_extern")
                        : [
                            "campus.pga_lasalle",
                            "campus.pga_upc",
                            "campus.pga_mundet"
                          ].includes(value.type)
                        ? "(" + $t("extern") + ")"
                        : !["campus.pga_virtual"].includes(value.type)
                        ? "(" + $t("intern") + ")"
                        : ""
                    }}
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
            <!-- <select v-model="person.edition" :class="error.person.edition ? 'error' : ''" class="shadow">
                            <option v-for="(value, key) in campus_types" :value="key" :key="key">
                                {{$t(value.type)}}
                            </option>
                        </select> -->
          </div>

          <!-- Modality -->
          <div class="item">
            <template
              v-if="
                person.edition &&
                  campus_types[person.edition].type != 'campus.pga_virtual'
              "
            >
              <label
                >{{ $t("titles.modality") }} <span class="obligatory">*</span>
              </label>
              <v-radio-group
                v-model="person.modality"
                row
                @change="
                  brotherDiscount();
                  calculatePrice();
                "
              >
                <v-radio
                  value="1"
                  v-if="
                    ['campus.risingstars', 'campus.pga_damian'].includes(
                      campus_types[person.edition].type
                    )
                  "
                >
                  <template v-slot:label>
                    <span :class="error.person.modality ? 'obligatory' : ''">{{
                      $t("intern")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio
                  value="2"
                  v-if="
                    ['campus.pga_mundet', 'campus.pga_lasalle'].includes(
                      campus_types[person.edition].type
                    )
                  "
                >
                  <template v-slot:label>
                    <span :class="error.person.modality ? 'obligatory' : ''">{{
                      $t("extern")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </template>
          </div>

          <h3 :style="cssProps">{{ $t("titles.player_nike") }}</h3>

          <!-- Nom -->
          <div class="item">
            <label>
              {{ $t("params.name") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              :class="error.person.name ? 'error' : ''"
              type="text"
              v-model.trim="person.name"
              autocomplete="new-text"
            />
          </div>

          <!-- Cognom -->
          <div class="item">
            <label>
              {{ $t("params.surname") }} <span class="obligatory">*</span>
            </label>
            <input
              class="upper shadow"
              :class="error.person.surname ? 'error' : ''"
              type="text"
              v-model.trim="person.surname"
              autocomplete="new-text"
            />
          </div>

          <!-- DNI -->
          <div class="item">
            <label
              >{{ $t("params.participant_document") }}
              <span class="obligatory">*</span>
              <span class="obligatory error" v-if="error.person.invalit_dni">{{
                " " + $t("errors.invalit_dni")
              }}</span>
              <span class="obligatory error" v-if="error.person.invalit_nie">{{
                " " + $t("errors.invalit_nie")
              }}</span>
              <span class="obligatory error" v-if="error.duplicated_dni">{{
                " " + $t("errors.same_dni")
              }}</span>
            </label>
            <div>
              <v-radio-group v-model="person.document_type" row>
                <v-radio :label="$t('params.dni')" value="1"></v-radio>
                <v-radio :label="$t('params.nie')" value="2"></v-radio>
                <v-radio :label="$t('params.passport')" value="3"></v-radio>
              </v-radio-group>
              <input
                v-if="person.document_type == '1'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : ''
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="person.document_type == '2'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : ''
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
                class="upper shadow"
                autocomplete="new-text"
              />
              <input
                v-if="person.document_type == '3'"
                v-bind:class="[
                  error.person.dni ? 'error' : '',
                  error.duplicated_dni ? 'error' : ''
                ]"
                type="text"
                v-model="person.dni"
                :placeholder="$t('params.passport')"
                class="upper shadow"
                autocomplete="new-text"
              />
            </div>
          </div>

          <!-- Birthday -->
          <div class="item" id="birthday">
            <label>
              {{ $t("params.birthday") }}
              <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_birthday">
                {{
                  $t("errors.birthday_campus", { a: min_age, b: max_age })
                }}</span
              >
            </label>
            <!-- <input v-bind:class="error.person.birthday ? 'error' : ''" type="date" class="shadow" v-model="person.birthday" autocomplete="new-text"> -->
            <v-menu
              v-model="dialog_birthday"
              autocomplete="new-text"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              :class="error.person.birthday ? 'error' : ''"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  prepend-icon="event"
                  v-model="person.parsedBirthday"
                  @click:prepend="dialog_birthday = true"
                  :placeholder="'DD/MM/YYYY'"
                  :class="error.person.birthday ? 'error' : ''"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="person.birthday"
                @input="(dialog_birthday = false), formatBirthday()"
              ></v-date-picker>
            </v-menu>
          </div>

          <!-- GENDER -->
          <div class="item">
            <label>
              {{ $t("params.gender") }} <span class="obligatory">*</span>
            </label>
            <v-radio-group v-model="person.gender" row>
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.gender ? 'obligatory' : ''">{{
                    $t("gender.male")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.gender ? 'obligatory' : ''">{{
                    $t("gender.female")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Country -->
          <div class="item" id="country">
            <label>
              {{ $t("params.country") }} <span class="obligatory">*</span>
            </label>
            <v-autocomplete
              :class="error.person.country ? 'error' : ''"
              v-model="person.country_id"
              :items="Object.values(countries)"
              item-text="name"
              item-value="id"
              no-data
              :browser-autocomplete="'asd2saS<'"
              hide-no-data
            >
            </v-autocomplete>
          </div>

          <!-- Address -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label
              >{{ $t("params.address") }} <span class="obligatory">*</span>
            </label>
            <input
              v-bind:class="error.person.address ? 'error' : ''"
              type="text"
              class="shadow"
              v-model.trim="person.address"
              autocomplete="new-text"
            />
          </div>

          <!-- CP -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label
              >{{ $t("params.cp") }} <span class="obligatory">*</span>
            </label>
            <input
              :class="error.person.cp ? 'error' : ''"
              type="text"
              class="shadow"
              v-model="person.cp"
              autocomplete="new-text"
            />
          </div>

          <!-- City -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label
              >{{ $t("params.city") }} <span class="obligatory">*</span>
            </label>
            <input
              :class="error.person.city ? 'error' : ''"
              type="text"
              class="shadow"
              v-model.trim="person.city"
              autocomplete="new-text"
            />
          </div>

          <!-- State -->
          <div class="item">
            <label
              >{{ $t("params.state") }} <span class="obligatory">*</span>
            </label>
            <input
              :class="error.person.state ? 'error' : ''"
              type="text"
              class="shadow"
              v-model.trim="person.state"
              autocomplete="new-text"
            />
          </div>

          <!-- Phone -->
          <div class="item">
            <label
              >{{ $t("params.phone") }}
              <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_phone">
                {{ $t("errors.phone") }}
              </span>
              <span class="obligatory" v-if="error.duplicated_phone">
                {{ $t("errors.duplicated_phones") }}
              </span>
            </label>
            <vue-tel-input
              v-model="person.phone"
              @input="personPhone"
              autocomplete="new-text"
              style="border:none"
              :class="error.person.phone ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Mobile -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label
              >{{ $t("params.phone2") }}
              <span class="obligatory">*</span>
              <span class="obligatory" v-if="error.person.invalit_mobile">
                {{ $t("errors.phone") }}
              </span>
              <span class="obligatory" v-if="error.duplicated_phone">
                {{ $t("errors.duplicated_phones") }}
              </span>
            </label>
            <vue-tel-input
              v-model="person.mobile"
              @input="personMobile"
              autocomplete="new-text"
              style="border:none"
              :class="error.person.mobile ? 'error' : ''"
              :placeholder="''"
              defaultCountry="ES"
              :inputOptions="{ showDialCode: true }"
            ></vue-tel-input>
          </div>

          <!-- Email -->
          <div class="item">
            <label
              >{{ $t("params.email") }} <span class="obligatory">*</span>
              <span v-if="error.person.invalit_email" class="obligatory">
                {{ $t("errors.email") }}</span
              >
            </label>
            <input
              v-bind:class="error.person.email ? 'error' : ''"
              type="email"
              class="shadow"
              v-model="person.email"
              autocomplete="new-text"
            />
          </div>

          <!-- Medicament -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>{{ $t("params.medicamento") }}</label>
            <input
              type="text"
              class="shadow"
              v-model="person.medicament"
              :placeholder="$t('params.have_medicaments')"
              autocomplete="new-text"
            />
          </div>

          <!-- Allergy -->
          <div
            class="item"
            id="alergy"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>{{ $t("params.alergy") }}</label>
            <v-select
              :class="error.alergy ? 'error' : ''"
              v-model="person.alergy"
              :items="Object.values(alergy)"
              item-text="name"
              item-value="id"
              multiple
              :browser-autocomplete="'asd2saS<'"
              ref="alergy"
              @change="checkAlergies"
              id="alergies"
              style="padding:0"
              attach
              :menuProps="{
                closeOnClick: false,
                closeOnContentClick: false,
                maxHeight: 300,
                openOnClick: false
              }"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip @input="removeAlergy(item)">
                  {{ $t(item.name) }}
                </v-chip>
              </template>
            </v-select>
          </div>

          <!-- Other allergies -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>{{ $t("params.other_allergies") }}</label>
            <input
              type="text"
              v-model="person.other_allergies"
              autocomplete="new-text"
            />
          </div>

          <!-- Diet -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>{{ $t("params.diet") }}</label>
            <select v-model="person.diet">
              <option v-for="(value, key) in diets" :key="key" :value="key">
                {{ $t(value.name) }}
              </option>
            </select>
          </div>

          <!-- Swim -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>{{ $t("swim") }} <span class="obligatory">*</span> </label>
            <v-radio-group v-model="person.swim" row>
              <v-radio value="1">
                <template v-slot:label>
                  <span :class="error.person.swim ? 'obligatory' : ''">{{
                    $t("si")
                  }}</span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span :class="error.person.swim ? 'obligatory' : ''">{{
                    $t("no")
                  }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Join Campus -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>
              {{ $t("campus.join") }} <span class="obligatory">*</span>
            </label>
            <select
              v-model="person.joinCampus"
              :class="{ error: error.person.joinCampus }"
              class="shadow"
            >
              <option
                v-for="(value, key) in joinCampus"
                :value="key"
                :key="key"
              >
                {{ $t("campus." + value.name) }}
              </option>
            </select>
          </div>

          <!-- Shirt Size -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>
              {{ $t("campus.size") }} <span class="obligatory">* </span>
              <span
                ><a :href="clothing_size_link" target="_blank"
                  >({{ $t("descriptions.clothing_size") }})</a
                ></span
              >
            </label>
            <select
              v-model="person.shirt_size"
              :class="error.person.shirt_size ? 'error' : ''"
              class="shadow"
            >
              <option
                v-for="(value, key) in shirt_sizes"
                :value="key"
                :key="key"
              >
                {{ $t("campus." + value.name) }}
              </option>
            </select>
          </div>

          <!-- Club Name -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label> {{ $t("campus.club_name") }} </label>
            <input
              class="upper shadow"
              type="text"
              v-model.trim="person.club_name"
              autocomplete="new-text"
            />
          </div>

          <!-- How meet -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label
              >{{ $t("params.how_meet") }} <span class="obligatory">*</span>
            </label>
            <select
              class="shadow"
              v-bind:class="error.person.how_meet ? 'error' : ''"
              v-model="person.how_meet"
            >
              <option
                v-for="type in how_meet"
                v-bind:value="type.id"
                v-bind:key="type.id"
              >
                {{ $t(type.name) }}
              </option>
            </select>
          </div>

          <!-- Language -->
          <div class="item">
            <label
              >{{ $t("params.communication") }}
              <span class="obligatory">*</span>
            </label>
            <v-radio-group
              v-model="person.language"
              row
              autocomplete="new-text"
            >
              <v-radio
                v-for="language in languages"
                v-bind:value="language.id"
                v-bind:key="language.id"
              >
                <template v-slot:label>
                  <span :class="error.person.language ? 'obligatory' : ''">
                    {{ language.name }}
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Lottery -->
          <div
            class="item"
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <label>{{ $t("params.lottery") }}</label>
            <v-checkbox v-model="person.lottery">
              <template v-slot:label>
                <span v-html="$t('campus.lottery', { s: lottery_link })"></span>
              </template>
            </v-checkbox>
          </div>

          <div class="item"></div>

          <!-- Observation -->
          <!-- <div class="item">
                        <label>{{$t('params.observacions')}} <span>{{$t('descriptions.observations')}}</span> </label>
                        <textarea type="text" v-model="person.observations" maxlength="255"></textarea>
                    </div> -->

          <template
            v-if="
              !person.edition ||
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <!-- Legal Guardian -->
            <h3 :style="cssProps">{{ $t("titles.player_tutor") }}</h3>

            <!-- Name -->
            <div class="item">
              <label
                >{{ $t("params.tutor_name") }} <span class="obligatory">*</span>
              </label>
              <input
                class="upper shadow"
                v-bind:class="error.legal_guardian.name ? 'error' : ''"
                type="text"
                v-model.trim="legal_guardian.name"
                autocomplete="new-text"
              />
            </div>

            <!-- Surname -->
            <div class="item">
              <label>
                {{ $t("params.surname") }} <span class="obligatory">*</span>
              </label>
              <input
                class="upper shadow"
                v-bind:class="error.legal_guardian.surname ? 'error' : ''"
                type="text"
                v-model.trim="legal_guardian.surname"
                autocomplete="new-text"
              />
            </div>

            <!-- Emergency Phone -->
            <div class="item">
              <label
                >{{ $t("params.emergency_phone_pga") }}
                <span class="obligatory">*</span>
                <span class="obligatory" v-if="error.person.invalit_phone2">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <vue-tel-input
                v-model="person.phone2"
                @input="personPhone2"
                autocomplete="new-text"
                style="border:none"
                :class="error.person.phone2 ? 'error' : ''"
                :placeholder="''"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
              ></vue-tel-input>
            </div>

            <!-- Email -->
            <!-- <div class="item">
                        <label> {{$t('params.email')}} <span class="obligatory">*</span> <span class="obligatory" v-if="error.legal_guardian.invalit_email"> {{$t('errors.email')}}</span> </label>
                        <input v-bind:class="error.legal_guardian.email ? 'error' : ''" type="email" class="shadow" v-model="legal_guardian.email" autocomplete="new-text">
                    </div> -->

            <!-- DNI -->
            <div class="item">
              <label
                >{{ $t("params.parent_document") }}
                <span class="obligatory">*</span>
                <span
                  class="obligatory error"
                  v-if="error.legal_guardian.invalit_dni"
                  >{{ " " + $t("errors.invalit_dni") }}</span
                >
                <span
                  class="obligatory error"
                  v-if="error.legal_guardian.invalit_nie"
                  >{{ " " + $t("errors.invalit_nie") }}</span
                >
                <span class="obligatory error" v-if="error.duplicated_dni">{{
                  " " + $t("errors.same_dni")
                }}</span>
              </label>
              <div>
                <v-radio-group v-model="legal_guardian.document_type" row>
                  <v-radio :label="$t('params.dni')" value="1"></v-radio>
                  <v-radio :label="$t('params.nie')" value="2"></v-radio>
                  <v-radio :label="$t('params.passport')" value="3"></v-radio>
                </v-radio-group>
                <input
                  v-if="legal_guardian.document_type == '1'"
                  v-bind:class="[
                    error.legal_guardian.dni ? 'error' : '',
                    error.duplicated_dni ? 'error' : ''
                  ]"
                  type="text"
                  v-model="legal_guardian.dni"
                  :placeholder="
                    $t('params.dni') + '  ' + $t('params.dni_format')
                  "
                  class="upper shadow"
                  autocomplete="new-text"
                />
                <input
                  v-if="legal_guardian.document_type == '2'"
                  v-bind:class="[
                    error.legal_guardian.dni ? 'error' : '',
                    error.duplicated_dni ? 'error' : ''
                  ]"
                  type="text"
                  v-model="legal_guardian.dni"
                  :placeholder="
                    $t('params.nie') + '  ' + $t('params.nie_format')
                  "
                  class="upper shadow"
                  autocomplete="new-text"
                />
                <input
                  v-if="legal_guardian.document_type == '3'"
                  v-bind:class="[
                    error.legal_guardian.dni ? 'error' : '',
                    error.duplicated_dni ? 'error' : ''
                  ]"
                  type="text"
                  v-model="legal_guardian.dni"
                  :placeholder="$t('params.passport')"
                  class="upper shadow"
                  autocomplete="new-text"
                />
              </div>
            </div>
          </template>

          <h3 :style="cssProps">{{ $t("titles.total_cost") }}</h3>

          <!-- Total Cost -->
          <div class="item">
            <div
              id="price"
              v-if="
                person.edition &&
                  (person.modality ||
                    campus_types[person.edition].type == 'campus.pga_virtual')
              "
            >
              <div class="row">
                <span class="name">{{ $t("titles.total_cost") }}</span>
                <span class="value">{{ main_price }} &euro;</span>
              </div>
              <div id="discounts-list">
                <div class="row" v-if="person.brothers_discount">
                  <span class="name">{{
                    $t("descriptions.brother_discount")
                  }}</span>
                  <span class="value"
                    >- {{ person.modality == 1 ? 25 : 20 }} &euro;</span
                  >
                </div>

                <div v-if="person.brothers_discount" class="row total">
                  <span class="name">{{ $t("params.final_price") }}</span>
                  <span class="value"
                    >{{ parseInt(main_price) + parseInt(total) }} &euro;</span
                  >
                </div>

                <template
                  v-if="Object.keys(person.discount_applied).length > 0"
                >
                  <div class="row">
                    <span class="name">{{
                      $t(discounts[person.discount_applied.discount_id].name)
                    }}</span>
                    <span class="clickable" @click="deleteDiscount()">{{
                      $t("params.delete_discount")
                    }}</span>
                    <span class="value"
                      >{{
                        Math.abs(person.discount_applied.import) == 0
                          ? parseInt(main_price) * -1
                          : parseInt(person.discount_applied.import)
                      }}
                      &euro;</span
                    >
                  </div>

                  <div class="row total">
                    <span class="name">{{ $t("params.final_price") }}</span>
                    <span class="value"
                      >{{
                        parseInt(main_price) +
                          (Math.abs(parseInt(person.discount_applied.import)) ==
                          0
                            ? parseInt(main_price) * -1
                            : parseInt(person.discount_applied.import))
                      }}&euro;</span
                    >
                  </div>
                </template>
              </div>
            </div>
            <div v-else>
              <p>{{ $t("errors.no_campus") }}</p>
            </div>
          </div>

          <!-- Discounts -->
          <template
            v-if="
              Object.keys(person.discount_applied).length == 0 &&
                person.edition &&
                campus_types[person.edition].type != 'campus.pga_virtual'
            "
          >
            <div class="item">
              <span>{{ $t("params.discounts") }}</span>
              <v-checkbox
                v-model="person.brothers_discount"
                @change="brotherDiscount"
              >
                <template v-slot:label>
                  <span
                    v-html="
                      $t('descriptions.brothers_discount', {
                        a: brother_boarder.value,
                        b: brother_no_boarder.value
                      })
                    "
                  ></span>
                </template>
              </v-checkbox>

              <template
                v-if="
                  person.edition &&
                    campus_types[person.edition].type != 'campus.pga_virtual'
                "
              >
                <div>
                  <span v-if="error.invalit_discount_code" class="obligatory">{{
                    $t("errors.invalit_discount_code")
                  }}</span>
                  <span v-if="error.limit_discount_code" class="obligatory">{{
                    $t("errors.limit_used_discount_code")
                  }}</span>
                </div>

                <div class="item">
                  <input
                    class="text"
                    :class="
                      error.invalit_discount_code
                        ? 'error'
                        : '' || error.limit_discount_code
                        ? 'error'
                        : ''
                    "
                    v-model="person.discount"
                    v-on:keyup.enter="applyDiscount"
                  />
                </div>
                <div class="item">
                  <button
                    @click="applyDiscount"
                    class="discount"
                    :style="cssProps"
                  >
                    {{ $t("params.discount") }}
                  </button>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="item"></div>
          </template>

          <!-- Payment Method -->
          <template
            v-if="
              (Object.keys(person.discount_applied).length == 0 ||
                Math.abs(person.discount_applied.import) > 0) &&
                main_price > 0
            "
          >
            <div class="item">
              <label
                >{{ $t("params.payment_method") }}
                <span class="obligatory">*</span>
              </label>
              <v-radio-group v-model="person.payment_type">
                <template
                  v-for="payment_type in payments_type"
                  :value="payment_type.code"
                >
                  <v-radio :value="payment_type.code" :key="payment_type.code">
                    <template v-slot:label>
                      <span
                        :class="error.person.payment_type ? 'obligatory' : ''"
                        >{{ $t(payment_type.description) }}</span
                      >
                      <span v-if="payment_type.code == 1">
                        ({{
                          parseInt(main_price) + parseInt(total)
                        }}
                        &euro;)</span
                      >
                      <span v-else> ({{ payment_type.value }} &euro;)</span>
                    </template>
                  </v-radio>
                </template>
              </v-radio-group>
            </div>
          </template>

          <div class="item"></div>

          <h3 :style="cssProps">{{ $t("titles.terms_and_conditions") }}</h3>

          <div>
            <!-- Information -->
            <div>
              <v-checkbox v-model="information" class="terms_and_conditions">
                <template v-slot:label>
                  <span> {{ $t("descriptions.pga_information") }} </span>
                </template>
              </v-checkbox>
            </div>

            <!-- Terms and conditions -->
            <!-- <div>
                            <v-checkbox v-model="terms_and_conditions">
                                <template v-slot:label>
                                    <span :class="{'obligatory' : error.terms_and_conditions}">
                                        {{$t('descriptions.terms_and_conditions_1')}}
                                        <a target="_blank" :href="terms_and_conditions_link">{{$t('descriptions.terms_and_conditions_2')}}</a>
                                    </span>
                                </template>
                            </v-checkbox>
                        </div> -->

            <!-- Política de privacitat -->
            <div>
              <v-checkbox v-model="privacy_policy" class="terms_and_conditions">
                <template v-slot:label>
                  <span :class="{ obligatory: error.privacy_policy }">
                    {{ $t("descriptions.privacy_policy_1") }}
                    <a target="_blank" :href="privacy_policy_link">{{
                      $t("descriptions.privacy_policy_2")
                    }}</a>
                  </span>
                </template>
              </v-checkbox>
              <button class="information" v-on:click="openDialog()">
                {{ $t("more_information") }}
              </button>
            </div>

            <!-- Política de devolucions -->
            <div>
              <v-checkbox v-model="devolucions" class="terms_and_conditions">
                <template v-slot:label>
                  <span
                    v-bind:class="error.devolucions ? 'obligatory' : ''"
                    v-html="
                      $t('descriptions.devolucions', { s: devolucions_link })
                    "
                  ></span>
                </template>
              </v-checkbox>
            </div>

            <!-- captcha -->
            <span v-if="error.recaptcha" class="obligatory"
              >* {{ $t("errors.recaptcha") }}</span
            >
            <!-- <div class="g-recaptcha" :data-sitekey="captcha_key"></div> -->
            <vue-recaptcha
              :sitekey="captcha_key"
              @verify="recaptcha = true"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>

            <!-- Error Form -->
            <div>
              <span class="obligatory error-form" v-if="error.form">{{
                $t("errors.form")
              }}</span>
            </div>
          </div>

          <!-- Send -->
          <button
            :style="cssButton"
            type="button"
            id="send"
            v-on:click="validate()"
          >
            {{ $t("send") }}
          </button>

          <!-- Popup -->
          <!-- <v-dialog  v-model="dialog" width="600" class="modal" :hide-overlay="true" data-app>
                        <div id="popup1" style="padding-bottom: 0">
                            <div class="header">
                                <img v-on:click="closeDialog()" v-bind:src="'/img/error.svg'" alt="delete">
                            </div>
                            <div class="main">
                                <p class="title">{{$t('inscription-popup.title1')}}</p>
                                <p>{{'GANG EVENTS AND INVESTMENTS SL'}}</p>                                
                                <p class="title">{{$t('inscription-popup.title2')}}</p>
                                <p>{{$t('nike-popup.part2')}}</p>
                                <p class="title">{{$t('inscription-popup.title3')}}</p>
                                <p>{{$t('nike-popup.part3')}}</p>
                                <p class="title">{{$t('inscription-popup.title4')}}</p>
                                <p>{{$t('nike-popup.part4')}}</p>
                                <p class="title">{{$t('inscription-popup.title5')}}</p>
                                <p>{{$t('inscription-popup.part5')}}</p>
                                <p class="title">{{$t('inscription-popup.title6')}}</p>
                                <p v-html="$t('inscription-popup.part6', {s: privacy_policy_link})"></p> 
                            </div>
                        </div>
                    </v-dialog>  -->
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "InscripcionPauGasol",
  components: {
    i18n,
    VueRecaptcha
  },
  data() {
    return {
      person: {
        name: "",
        surname: "",
        dni: "",
        document_type: "1",
        birthday: "",
        parsedBirthday: "",
        gender: "",
        shirt_size: "",
        edition: "",
        modality: "",
        club_name: "",
        swim: "",
        address: "",
        city: "",
        state: "",
        cp: "",
        lottery: "",
        alergy: "",
        medicament: "",
        // observation: '',
        joinCampus: "",
        country_id: "",
        phone: "",
        mobile: "",
        phone2: "",
        phone_aux: "",
        mobile_aux: "",
        phone2_aux: "",
        other_allergies: "",
        diet: "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09", // NO TOCAR
        how_meet: "",
        language: "",
        email: "",
        brothers_discount: false,
        services: {},
        payment_type: 0,
        discount: "",
        discount_applied: {},
        total_discounts: []
      },
      legal_guardian: {
        name: "",
        surname: "",
        dni: "",
        document_type: "1"
        // mobile: '',
        // phone: '',
        // email: '',
        // mobile_aux: '',
        // phone_aux: ''
      },
      alergy: {},
      joinCampus: {},
      campus_types: {},
      shirt_sizes: {},
      countries: {},
      diets: {},
      how_meet: {},
      languages: {},
      privacy_policy: false,
      devolucions: false,
      devolucions_link: "",
      lottery_link: "",
      captcha_key: process.env.VUE_APP_CAPTCHA_KEY,
      min_age: 0,
      max_age: 0,
      dialog_birthday: false,
      total: 0,
      main_price: 0,
      services: {},
      discounts: {},
      brother_boarder: {},
      brother_no_boarder: {},
      payments_type: [],
      information: false,
      dialog: false,
      clothing_size_link: "",
      privacy_policy_link: "",
      terms_and_conditions_link: "",
      terms_and_conditions: false,
      more_info: "",
      error: {
        person: {
          name: false,
          surname: false,
          dni: false,
          invalit_dni: false,
          invalit_nie: false,
          birthday: false,
          gender: false,
          shirt_size: false,
          edition: false,
          modality: false,
          swim: false,
          country: false,
          address: false,
          city: false,
          state: false,
          cp: false,
          joinCampus: false,
          invalit_birthday: false,
          phone: false,
          mobile: false,
          phone2: false,
          invalit_phone: false,
          invalit_mobile: false,
          invalit_phone2: false,
          how_meet: false,
          language: false,
          cp: false,
          city: false,
          state: false,
          email: false,
          invalit_email: false,
          payment_type: false
        },
        legal_guardian: {
          name: false,
          surname: false,
          dni: false,
          // email: false,
          invalit_dni: false,
          invalit_nie: false
        },
        privacy_policy: false,
        devolucions: false,
        recaptcha: false,
        duplicated_dni: false,
        duplicated_discount_code: false,
        invalit_discount_code: false,
        limit_discount_code: false,
        duplicated_phone: false,
        terms_and_conditions: true
      },
      recaptcha: false
    };
  },

  created() {
    this.$overlay.loading();
    // get language
    this.lang = this.$route.params.lang;
    // check if isset
    if (!["ca", "es", "en"].includes(this.lang)) {
      this.lang = "ca";
    }
    i18n.loadLanguageAsync(this.lang);
    var self = this;
    // get form information
    this.$store
      .dispatch("getCampusInfo", { event_id: this.$route.params.event_id })
      .then(function() {
        // alergies
        self.alergy = JSON.parse(
          JSON.stringify(self.$store.getters["getAlergies"])
        );
        self.alergy["null"] = {
          id: "null",
          name: "no"
        };

        // update languages alergy
        for (let i in self.alergy) {
          self.alergy[i].name = i18n.t("alergy." + self.alergy[i].name);
        }
        self.person.alergy = ["null"];

        self.shirt_sizes = self.$store.getters["getShirtSizes"];
        self.campus_types = JSON.parse(
          JSON.stringify(self.$store.getters["getCampusTypePGA"])
        );
        self.joinCampus = self.$store.getters["getJoinCampus"];
        self.countries = self.$store.getters["getCountries"];
        self.diets = self.$store.getters["getDiets"];
        self.how_meet = self.$store.getters["getHowMeet"];
        self.languages = self.$store.getters["getLanguages"];
        self.services = self.$store.getters["getServices"];
        self.discounts = self.$store.getters["getDiscounts"];

        // loop for campus
        for (let i in self.campus_types) {
          // format date
          self.campus_types[i].start_date = moment(
            self.campus_types[i].start_date,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
          self.campus_types[i].end_date = moment(
            self.campus_types[i].end_date,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
        }

        // default language comunications
        for (let i in self.languages) {
          if (self.lang == self.languages[i].name) {
            self.person.language = i;
          }
        }

        // discounts
        for (let i in self.discounts) {
          // get brother boarder discount
          if (self.discounts[i].name.match("brothers_boader")) {
            self.brother_boarder = { ...self.discounts[i] };
          }

          // get brother no boarder discount
          if (self.discounts[i].name.match("brothers_no-boader")) {
            self.brother_no_boarder = { ...self.discounts[i] };
          }
        }
        self.$overlay.hide();
      })
      .catch(() => {
        self.$overlay.hide();
      });
    // devolucions
    switch (this.lang) {
      case "ca":
        this.devolucions_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/Politica-devoluciones-PGA-CAT-1.pdf";
        this.lottery_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/RIFA-CAT-2020.pdf";
        this.clothing_size_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/TALLES_PGA_2020_CAT.pdf";
        this.privacy_policy_link =
          "https://paugasolacademy.com/ca/politica-de-privacitat-i-proteccio-de-dades-de-caracter-personal/";
        // this.terms_and_conditions_link  =   'https://paugasolacademy.com/ca/politica-de-privacitat-i-proteccio-de-dades-de-caracter-personal/';
        this.more_info =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/MÁS-INFO-PGA-CAT.pdf";
        break;
      case "es":
        this.devolucions_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/Politica-devoluciones-PGA-ESP.pdf";
        this.lottery_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/RIFA-ESP-2020.pdf";
        this.clothing_size_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/TALLAS_PGA_2020_ESP.pdf";
        this.privacy_policy_link =
          "https://paugasolacademy.com/politica-de-privacidad-y-proteccion-de-datos-de-caracter-personal/";
        // this.terms_and_conditions_link  =   'https://paugasolacademy.com/politica-de-privacidad-y-proteccion-de-datos-de-caracter-personal/';
        this.more_info =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/MÁS-INFO-PGA-ESP.pdf";
        break;
      case "en":
        this.devolucions_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/Politica-devoluciones-PGA-ENG-1.pdf";
        this.lottery_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/RIFA-ENG-2020.pdf";
        this.clothing_size_link =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/TALLAS_PGA_2020_ENG.pdf";
        this.privacy_policy_link =
          "https://paugasolacademy.com/en/privacy-policy-and-data-protection/";
        // this.terms_and_conditions_link  =   'https://paugasolacademy.com/en/privacy-policy-and-data-protection/';
        this.more_info =
          "https://paugasolacademy.com/wp-content/uploads/2020/01/MÁS-INFO-PGA-ENG.pdf";
        break;
    }
  },

  methods: {
    removeAlergy(item) {
      let index = this.person.alergy.indexOf(item.id);
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.person.alergy));
        aux.splice(index, 1);
        this.person.alergy = aux;
      }
      this.checkAlergies();
    },

    checkAlergies() {
      if (this.person.alergy.length > 0) {
        let pos = this.person.alergy.indexOf("null");
        if (pos >= 0) this.person.alergy.splice(pos, 1);
      } else {
        this.person.alergy.push("null");
      }
    },

    personPhone(input, oResult) {
      this.person.phone_aux = oResult;
    },

    personMobile(input, oResult) {
      this.person.mobile_aux = oResult;
    },

    personPhone2(input, oResult) {
      this.person.phone2_aux = oResult;
    },

    formatBirthday() {
      this.person.parsedBirthday = moment(this.person.birthday).format(
        "DD/MM/YYYY"
      );
    },

    openDialog() {
      // this.dialog = true;
      window.open(this.more_info);
    },

    closeDialog() {
      this.dialog = false;
    },

    brotherDiscount() {
      // add brothers_discount
      this.person.brothers_discount
        ? // add brother discount
          this.person.modality == 1
          ? (this.total = this.brother_boarder.value * -1)
          : (this.total = this.brother_no_boarder.value * -1)
        : // removed brother discount
          (this.total = 0);
    },

    calculatePrice() {
      this.main_price = 0;
      this.person.services = {};
      this.payments_type = [];
      this.person.payment_type = 0;

      // check if selected edition and modality
      if (
        this.person.edition &&
        (this.person.modality ||
          this.campus_types[this.person.edition].type == "campus.pga_virtual")
      ) {
        if (
          this.campus_types[this.person.edition].type != "campus.risingstars"
        ) {
          // add element 100%
          this.payments_type.push({
            code: 1,
            value: this.main_price,
            description: "campus.100"
          });
        }

        // loop for each service
        for (let i in this.services) {
          switch (this.campus_types[this.person.edition].type) {
            // only boarder
            case "campus.risingstars":
              if (this.services[i].name == "pga.services.rising_stars") {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 4,
                  value: 250,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 4,
                  value: 250,
                  description: "campus.deposit"
                };
              }
              break;

            // boarder and no boarder
            case "campus.pga_mundet":
              // boarder
              if (
                this.person.modality == 1 &&
                this.services[i].name == "pga.services.pga_int"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 3,
                  value: 200,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 3,
                  value: 200,
                  description: "campus.deposit"
                };
              }
              // no boarder
              if (
                this.person.modality == 2 &&
                this.services[i].name == "pga.services.pga_ext"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 2,
                  value: 150,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 2,
                  value: 150,
                  description: "campus.deposit"
                };
              }

              this.payments_type[0].value = this.main_price;

              break;

            // no boarder
            case "campus.pga_upc":
              if (this.services[i].name == "pga.services.pga_ext") {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 2,
                  value: 150,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 2,
                  value: 150,
                  description: "campus.deposit"
                };
              }

              this.payments_type[0].value = this.main_price;

              break;

            // boarder and no boarder
            case "campus.pga_minibasket":
              // boarder
              if (
                this.person.modality == 1 &&
                this.services[i].name == "pga.services.pga_int"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 3,
                  value: 200,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 3,
                  value: 200,
                  description: "campus.deposit"
                };
              }
              // no boarder
              if (
                this.person.modality == 2 &&
                this.services[i].name == "pga.services.pga_ext"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 2,
                  value: 150,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 3,
                  value: 150,
                  description: "campus.deposit"
                };
              }

              this.payments_type[0].value = this.main_price;

              break;
            // boarder and no boarder
            case "campus.pga_lasalle":
              // boarder
              if (
                this.person.modality == 1 &&
                this.services[i].name == "pga.services.pga_int"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 2,
                  value: 200,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 3,
                  value: 200,
                  description: "campus.deposit"
                };
              }
              // no boarder
              if (
                this.person.modality == 2 &&
                this.services[i].name == "pga.services.pga_ext"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 2,
                  value: 150,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 3,
                  value: 150,
                  description: "campus.deposit"
                };
              }

              this.payments_type[0].value = this.main_price;

              break;
            // boarder and no boarder
            case "campus.pga_damian":
              // boarder
              if (
                this.person.modality == 1 &&
                this.services[i].name == "pga.services.pga_int"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 2,
                  value: 200,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 3,
                  value: 200,
                  description: "campus.deposit"
                };
              }
              if (
                this.person.modality == 2 &&
                this.services[i].name == "pga.services.pga_ext"
              ) {
                this.main_price = parseInt(this.services[i].import);
                this.person.services[0] = this.services[i];
                this.payments_type.push({
                  code: 2,
                  value: 150,
                  description: "campus.deposit"
                });
                this.person.services[1] = {
                  code: 3,
                  value: 150,
                  description: "campus.deposit"
                };
              }
              break;
            case "campus.pga_virtual":
              // boarder
              if (this.services[i].name == "pga.services.virtual") {
                this.main_price = parseInt(this.services[i].import);
              }
              this.person.services[0] = this.services[i];
              break;
          }
        }
      }
    },

    validate() {
      let validate = true;

      // campus
      if (isEmpty(this.person.edition)) {
        this.error.person.edition = true;
        validate = false;
      } else {
        this.error.person.edition = false;
      }

      // modality
      if (
        isEmpty(this.person.modality) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.modality = true;
        validate = false;
      } else {
        this.error.person.modality = false;
      }

      // nom
      if (isEmpty(this.person.name)) {
        this.error.person.name = true;
        validate = false;
      } else {
        this.error.person.name = false;
      }

      // cognom
      if (isEmpty(this.person.surname)) {
        this.error.person.surname = true;
        validate = false;
      } else {
        this.error.person.surname = false;
      }

      // DNI

      // dni nie passport
      if (isEmpty(this.person.dni)) {
        this.error.person.dni = true;
        validate = false;
      } else {
        // dni
        if (this.person.document_type == "1") {
          // remove error nie
          this.error.person.invalit_nie = false;
          // validate dni
          if (!validateDocument(this.person.dni, 1)) {
            this.error.person.invalit_dni = true;
            this.error.person.dni = true;
            validate = false;
            // valit document
          } else {
            this.error.person.invalit_dni = false;
            this.error.person.dni = false;
          }
        }
        // nie
        if (this.person.document_type == "2") {
          // remove error dni
          this.error.person.invalit_dni = false;
          // validate nie
          if (!validateDocument(this.person.dni, 2)) {
            this.error.person.invalit_nie = true;
            this.error.person.dni = true;
            validate = false;
            // valit document
          } else {
            this.error.person.invalit_nie = false;
            this.error.person.dni = false;
          }
        }
      }

      // birthday
      if (
        isEmpty(this.person.birthday) ||
        this.person.parsedBirthday.trim().length != 10
      ) {
        this.error.person.birthday = true;
        validate = false;
      } else {
        if (this.validateYear()) {
          this.error.person.birthday = false;
          this.error.person.invalit_birthday = false;
        } else {
          this.error.person.birthday = true;
          this.error.person.invalit_birthday = true;
          validate = false;
        }
      }

      // gender
      if (isEmpty(this.person.gender)) {
        this.error.person.gender = true;
        validate = false;
      } else {
        this.error.person.gender = false;
      }

      // shirt_size
      if (
        isEmpty(this.person.shirt_size) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.shirt_size = true;
        validate = false;
      } else {
        this.error.person.shirt_size = false;
      }

      // club name
      if (
        isEmpty(this.person.club_name) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      )
        this.person.club_name = "";

      // swim
      if (
        isEmpty(this.person.swim) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.swim = true;
        validate = false;
      } else {
        this.error.person.swim = false;
      }

      // country
      if (isEmpty(this.person.country_id)) {
        this.error.person.country = true;
        validate = false;
      } else {
        this.error.person.country = false;
      }

      // address
      if (
        isEmpty(this.person.address) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.address = true;
        validate = false;
      } else {
        this.error.person.address = false;
      }

      // cp
      if (
        isEmpty(this.person.cp) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.cp = true;
        validate = false;
      } else {
        this.error.person.cp = false;
      }

      // city
      if (
        isEmpty(this.person.city) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.city = true;
        validate = false;
      } else {
        this.error.person.city = false;
      }

      // state
      if (isEmpty(this.person.state)) {
        this.error.person.state = true;
        validate = false;
      } else {
        this.error.person.state = false;
      }

      // email
      if (isEmpty(this.person.email)) {
        this.error.person.email = true;
        validate = false;
        // validate email
      } else {
        // valit email
        if (validateEmail(this.person.email)) {
          this.error.person.email = false;
          this.error.person.invalit_email = false;
          // invalit email
        } else {
          validate = false;
          this.error.person.email = true;
          this.error.person.invalit_email = true;
        }
      }

      // phone
      if (Object.keys(this.person.phone_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.phone_aux.isValid) {
          // ok save phone
          this.person.phone = this.person.phone_aux.number.e164;
          // remove  errors
          this.error.person.phone = false;
          this.error.person.invalit_phone = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_phone = true;
          this.error.person.phone = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.person.phone = true;
        validate = false;
      }

      // mobile
      if (Object.keys(this.person.mobile_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.mobile_aux.isValid) {
          // ok save phone
          this.person.mobile = this.person.mobile_aux.number.e164;
          // remove  errors
          this.error.person.mobile = false;
          this.error.person.invalit_mobile = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_mobile = true;
          this.error.person.mobile = true;
          validate = false;
        }
        // empty mobile
      } else if (
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.mobile = true;
        validate = false;
      }

      // emergency phone
      if (Object.keys(this.person.phone2_aux).length > 0) {
        // validate if club mobile is valid
        if (this.person.phone2_aux.isValid) {
          // ok save phone
          this.person.phone2 = this.person.phone2_aux.number.e164;
          // remove  errors
          this.error.person.phone2 = false;
          this.error.person.invalit_phone2 = false;
          // invalit mobile number
        } else {
          this.error.person.invalit_phone2 = true;
          this.error.person.phone2 = true;
          validate = false;
        }
        // empty mobile
      } else if (
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.phone2 = true;
        validate = false;
      }

      // lottery
      // if(isEmpty(this.person.lottery)) this.person.lottery = '';

      // alergy
      // if(isEmpty(this.person.alergy)) this.person.alergy = '';

      // medicament
      if (
        isEmpty(this.person.medicament) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      )
        this.person.medicament = "";

      // how meet
      if (
        isEmpty(this.person.how_meet) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.how_meet = true;
        validate = false;
      } else {
        this.error.person.how_meet = false;
      }

      // language
      if (isEmpty(this.person.language)) {
        this.error.person.language = true;
        validate = false;
      } else {
        this.error.person.language = false;
      }

      // observations
      // if(isEmpty(this.person.observations)) this.person.observations = '';

      // join campus
      if (
        isEmpty(this.person.joinCampus) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.joinCampus = true;
        validate = false;
      } else {
        this.error.person.joinCampus = false;
      }

      // name
      if (
        isEmpty(this.legal_guardian.name) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.legal_guardian.name = true;
        validate = false;
      } else {
        this.error.legal_guardian.name = false;
      }

      // surname
      if (
        isEmpty(this.legal_guardian.surname) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.legal_guardian.surname = true;
        validate = false;
      } else {
        this.error.legal_guardian.surname = false;
      }

      // dni

      // Responsable dni
      if (
        isEmpty(this.legal_guardian.dni) &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.legal_guardian.dni = true;
        validate = false;
      } else if (
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        // dni
        if (this.legal_guardian.document_type == "1") {
          // remove error nie
          this.error.legal_guardian.invalit_nie = false;
          // validate dni
          if (!validateDocument(this.legal_guardian.dni, 1)) {
            this.error.legal_guardian.invalit_dni = true;
            // valit document
          } else {
            this.error.legal_guardian.invalit_dni = false;
            this.error.legal_guardian.dni = false;
          }
        }
        // nie
        if (this.legal_guardian.document_type == "2") {
          // remove error dni
          this.error.legal_guardian.invalit_dni = false;
          // validate nie
          if (!validateDocument(this.legal_guardian.dni, 2)) {
            this.error.legal_guardian.invalit_nie = true;
            // valit document
          } else {
            this.error.legal_guardian.invalit_nie = true;
            this.error.legal_guardian.dni = false;
          }
        }
      }

      // // mobile
      // if(Object.keys(this.legal_guardian.mobile_aux).length > 0){
      //     // validate if mobile is valid
      //     if(this.legal_guardian.mobile_aux.isValid){
      //         // ok, save phone
      //         this.legal_guardian.mobile = this.legal_guardian.mobile_aux.number.e164
      //         // remove errors
      //         this.error.legal_guardian.mobile = false;
      //         this.error.legal_guardian.invalit_mobile = false;
      //     // invalit mobile number
      //     } else {
      //         this.error.legal_guardian.mobile = true;
      //         this.error.legal_guardian.invalit_mobile = true;
      //         validate = false;
      //     }
      // // empty mobile
      // } else {
      //     this.error.legal_guardian.mobile = true;
      //     validate = false;
      // }

      // // phone
      // if(Object.keys(this.legal_guardian.phone_aux).length > 0){
      //     // validate if mobile is valid
      //     if(this.legal_guardian.phone_aux.isValid){
      //         // ok, save phone
      //         this.legal_guardian.phone = this.legal_guardian.phone_aux.number.e164
      //         // remove errors
      //         this.error.legal_guardian.phone = false;
      //         this.error.legal_guardian.invalit_phone = false;
      //     // invalit mobile number
      //     } else {
      //         this.error.legal_guardian.phone = true;
      //         this.error.legal_guardian.invalit_phone = true;
      //         validate = false;
      //     }
      // // empty mobile
      // } else {
      //     this.error.legal_guardian.phone = true;
      //     validate = false;
      // }

      // payment_type
      if (
        this.person.payment_type == 0 &&
        Object.keys(this.person.discount_applied).length == 0 &&
        this.campus_types[this.person.edition].type != "campus.pga_virtual"
      ) {
        this.error.person.payment_type = true;
        validate = false;
      } else {
        this.error.person.payment_type = false;
      }

      // email
      // if(isEmpty(this.legal_guardian.email)){
      //     this.error.legal_guardian.email = true;
      //     validate = false;
      // // validate email
      // } else {
      //     // valit email
      //     if(validateEmail(this.legal_guardian.email)){
      //         this.error.legal_guardian.email = false;
      //         this.error.legal_guardian.invalit_email = false;
      //     } else {
      //         validate = false;
      //         this.error.legal_guardian.email = true;
      //         this.error.legal_guardian.invalit_email = true;
      //     }
      // }

      // terms_and_conditions
      // if(!this.terms_and_conditions){
      //     this.error.terms_and_conditions = true;
      //     validate = false;
      // } else {
      //     this.error.terms_and_conditions = false;
      // }

      // política de privacitat
      if (!this.privacy_policy) {
        this.error.privacy_policy = true;
        validate = false;
      } else {
        this.error.privacy_policy = false;
      }

      // política de devolucions
      if (!this.devolucions) {
        this.error.devolucions = true;
        validate = false;
      } else {
        this.error.devolucions = false;
      }

      // google captcha
      // try {
      //     // validate recaptcha
      //     if(isEmpty(grecaptcha.getResponse())) {
      //         this.error.recaptcha = true;
      //         validate = false;
      //     } else {
      //         this.error.recaptcha = false;
      //     }
      // } catch(error) {
      //     this.error.recaptcha = false;
      // }

      if (!this.recaptcha) {
        this.error.recaptcha = true;
        validate = false;
      } else {
        this.error.recaptcha = false;
      }

      // validate if dni from participant is different from the legal guardian
      if (
        !isEmpty(this.person.dni) &&
        !isEmpty(this.legal_guardian.dni) &&
        this.person.dni == this.legal_guardian.dni
      ) {
        this.error.duplicated_dni = true;
        validate = false;
      } else {
        this.error.duplicated_dni = false;
      }

      // validate if phone1 is diferent from mobile
      if (
        !isEmpty(this.person.phone) &&
        !isEmpty(this.person.mobile) &&
        this.person.phone == this.person.mobile
      ) {
        this.error.duplicated_phone = true;
        this.error.person.mobile = true;
        this.error.person.phone = true;
        validate = false;
      } else {
        this.error.duplicated_phone = false;
        this.error.person.mobile = false;
        this.error.person.phone = false;
      }

      if (validate) {
        if (this.person.alergy.length == 1 && this.person.alergy[0] == "null")
          this.person.alergy = [];

        var self = this;
        this.$overlay.loading();
        this.$store
          .dispatch("joinPGACampus", {
            campus_id: self.$route.params.event_id,
            participant_edition: self.person.edition,
            participant_modality: self.person.modality,

            participant_name: self.person.name,
            participant_surname: self.person.surname,
            participant_dni: self.person.dni,
            participant_document_type: self.person.document_type,
            participant_birthday: self.person.birthday,
            participant_gender: self.person.gender,

            participant_country_id: self.person.country_id,
            participant_address: self.person.address,
            participant_cp: self.person.cp,
            participant_city: self.person.city,
            participant_state: self.person.state,

            participant_phone: self.person.phone,
            participant_mobile: self.person.mobile,
            participant_email: self.person.email,

            participant_medicament: self.person.medicament,
            participant_alergy:
              self.person.alergy.length == 1 && self.person.alergy[0] == "null"
                ? []
                : self.person.alergy,
            participant_other_allergies: self.person.other_allergies,
            participant_swim: self.person.swim ? 1 : 0,
            participant_diet: self.person.diet,

            participant_join_campus: self.person.joinCampus,
            participant_shirt_size: self.person.shirt_size,
            participant_club_name: self.person.club_name,
            participant_how_meet: self.person.how_meet,
            participant_lottery: self.person.lottery,

            participant_language: self.person.language,
            participant_information: self.information ? 1 : 0,

            participant_brothers_discount: self.person.brothers_discount
              ? 1
              : 0,
            participant_payment_type: self.person.payment_type,

            legal_guardian_name: self.legal_guardian.name,
            legal_guardian_surname: self.legal_guardian.surname,
            legal_guardian_document_type: self.legal_guardian.document_type,
            legal_guardian_dni: self.legal_guardian.dni,
            legal_guardian_phone: self.person.phone2,

            discounts: JSON.stringify(self.person.total_discounts),

            services: JSON.stringify(self.person.services)
            // legal_guardian_mobile:          self.legal_guardian.mobile,
            // legal_guardian_phone:           self.legal_guardian.phone
          })
          .then(function(response) {
            // redirect to mic api
            let oParams = self.$store.getters["getRedsysParams"];
            // console.log(oParams);
            window.top.location = oParams;
            self.$overlay.hide();
          })
          .catch(() => {
            self.$overlay.hide();
          });
      } else {
        this.error.form = true;
      }
    },

    validateYear() {
      let validate = true;

      // check campus type
      if (this.campus_types[this.person.edition]) {
        // check type
        if (
          this.campus_types[this.person.edition].type == "campus.risingstars"
        ) {
          this.min_age = 15;
          this.max_age = 20;
        } else if (
          this.campus_types[this.person.edition].type == "campus.pga_minibasket"
        ) {
          this.min_age = 8;
          this.max_age = 11;
        } else {
          this.min_age = 8;
          this.max_age = 17;
        }

        // get participant birthday
        let person_birthday = moment(this.person.birthday).format("DD/MM/YYYY");

        // get campus dates
        let campus_first_date = this.campus_types[this.person.edition]
          .start_date;
        let campus_last_date = this.campus_types[this.person.edition].end_date;

        // validate year
        if (
          moment(campus_first_date, "DD/MM/YYYY").year() -
            moment(person_birthday, "DD/MM/YYYY").year() >=
            this.min_age &&
          moment(campus_last_date, "DD/MM/YYYY").year() -
            moment(person_birthday, "DD/MM/YYYY").year() <=
            this.max_age + 1
        ) {
          // validate min_age
          if (
            moment(campus_first_date, "DD/MM/YYYY").year() -
              moment(person_birthday, "DD/MM/YYYY").year() ==
            this.min_age
          ) {
            // validate smaller month
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) <
              0
            ) {
              validate = false;
            }

            // validate same month
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) ==
              0
            ) {
              // day bigger than campus, invalid
              if (
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date() <
                0
              ) {
                validate = false;
              }
            }
          }

          // validate max_age
          if (
            moment(campus_last_date, "DD/MM/YYYY").year() -
              moment(person_birthday, "DD/MM/YYYY").year() ==
            this.max_age + 1
          ) {
            // validate first day from campus (MONTH)
            if (
              moment(campus_first_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) >
              0
            ) {
              validate = false;
            }

            // validate first day from campus (DAY)
            if (
              moment(campus_last_date, "DD/MM/YYYY").month() +
                1 -
                (moment(person_birthday, "DD/MM/YYYY").month() + 1) ==
              0
            ) {
              // validate peron day with the last day of the campus
              if (
                moment(campus_last_date, "DD/MM/YYYY").date() -
                  moment(person_birthday, "DD/MM/YYYY").date() >=
                0
              ) {
                validate = false;
              }
            }
          }
        } else {
          validate = false;
        }
      }

      return validate;
    },

    applyDiscount() {
      if (
        !isEmpty(this.person.discount) &&
        Object.keys(this.person.discount_applied).length == 0
      ) {
        var self = this;
        this.$store
          .dispatch("checkDiscount", {
            event_id: this.$route.params.event_id,
            code: this.person.discount,
            campus: this.person.edition,
            modality: this.person.modality
          })
          .then(function() {
            // get result
            let result = self.$store.getters["getPromotionalCode"];

            // valit code
            if (result.status) {
              self.person.discount_applied = result.data;
              self.person.discount = "";
              self.person.total_discounts = [
                self.person.discount_applied.discount_id
              ];
              // invalit code
            } else {
              // check if code is not correct (-2)
              if (result.error.code == -2) {
                self.error.invalit_discount_code = true;
              }

              // check limit (-3)
              if (result.error.code == -3) {
                self.error.limit_discount_code = true;
              }
            }
          });
      }
    },

    deleteDiscount() {
      this.person.discount_applied = {};
      this.person.total_discounts = [];
    }
  },

  computed: {
    cssProps() {
      return {
        "background-color": this.$store.getters["getEventColor"]
      };
    },
    cssButton() {
      return {
        background: this.$store.getters["getEventColor"]
      };
    }
  },

  watch: {
    "person.edition": function() {
      // validate modality for campus type
      switch (this.campus_types[this.person.edition].type) {
        case "campus.risingstars":
          this.person.modality = "1";
          break;
        case "campus.pga_upc":
          this.person.modality = "2";
          break;
        case "campus.pga_mundet":
        case "campus.pga_minibasket":
          this.person.modality = "";
          break;
      }

      // remove discount applied
      this.person.discount_applied = {};

      this.calculatePrice();
    },

    "person.parsedBirthday": function() {
      if (moment(this.person.parsedBirthday, "DD/MM/YYYY").isValid()) {
        this.person.birthday = moment(
          this.person.parsedBirthday,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
      }
    },

    "person.discount_applied": function() {
      // discount applied
      if (Object.keys(this.person.discount_applied).length) {
        // remove payment method
        this.person.payment_type = 0;

        // remmove brother discounts
        this.person.brothers_discount = false;
      }
    }
  }
};
</script>

<style lang="scss">
// iframe
body {
  //overflow: hidden
}

body::-webkit-scrollbar {
  width: 0;
}

#pga {
  background-color: #fff;
  margin: 0;
  padding: 5px;
  height: 100%;

  .error-form {
    margin: 0 auto;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }

  .obligatory {
    color: $alert-color !important;
    font-weight: bold !important;
  }

  .clickable {
    margin-left: 10px;
    color: $alert-color !important;
    font-weight: bold !important;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  hr {
    background-color: #ccc;
    margin: 30px auto;
    width: 95%;
    background-color: transparent;
  }

  h2,
  h3,
  h4,
  h6 {
    // font-family: AvantGarde-Bold;
    color: $main-color !important;
    text-transform: uppercase;
  }

  h3 {
    font-size: 24px;
    background: #172654;
    color: #fff !important;
    padding: 4px;
  }

  h5 {
    font-weight: normal;
    // font-family: Roboto;
  }

  h6 {
    font-size: 18px;
    background: #eee;
    color: #999 !important;
    padding: 8px;
  }

  .alert {
    background-color: #e5faff;
    padding: 15px;
    width: 98%;
    margin: 20px auto;
    font-size: 16px;
  }

  .container.fluid.grid-list-md {
    padding: 0;
  }

  h2 {
    text-align: center;
    text-transform: uppercase;
    font-style: italic;
    // font-family: AvantGarde-Bold;
  }

  .v-menu__content {
    margin-top: 43px;

    * {
      text-decoration: none !important;
    }
  }

  a {
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
    // font-family: AvantGarde-Bold;
  }

  .box {
    width: 100%;
    margin: 0 auto;
    height: auto;
    overflow: auto;
    text-align: center;
    // font-family: AvantGarde-Bold;

    .message.error {
      color: $warning-color;
      // font-family: AvantGarde-Bold;
    }

    label {
      font-family: AvantGarde-Bold;
      font-size: 14px;
      margin-bottom: 3px;
      // padding: 0;
      // margin-bottom: 5px;
      display: block;
      color: black;
      font-weight: bold;
    }

    #country {
      .v-input {
        border: none;
      }
    }

    .item {
      width: calc(50% - 40px);
      margin: 10px 20px;
      display: inline-block;
      vertical-align: top;

      input,
      select,
      .v-autocomplete .v-input__slot,
      textarea,
      .v-select {
        width: 100%;
        padding: 5px 6px;
        margin-bottom: 0;
        border: 1px solid $main-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;
        // font-family: Roboto-Light;
        // font-weight: lighter;

        &::placeholder {
          color: $dark-color;
          // font-family: Roboto-Light;
          // font-weight: lighter;
          opacity: 0.5;
        }

        &.shadow:focus {
          border-color: #66afe9;
          outline: 0;
          border-left: 6px solid #66afe9;
        }
      }

      .discount {
        padding: 5px 6px;
        margin-bottom: 0;
        border: 1px solid $main-color;
        outline: none;
        font-size: 11pt;
        border-radius: 3px;
        color: $dark-color;
        // background: #000 !important;
        color: $secondary-color;
        &:hover {
          background: rgb(255, 70, 0);
        }
      }

      .v-autocomplete,
      .v-select {
        margin-top: 0;
        padding-top: 0;
        font-family: AvantGarde-Bold;
        .v-input__control {
          font-family: AvantGarde-Bold;
          .v-input__slot {
            margin: 0;
            padding: 0;

            &:after,
            &:before {
              content: "";
              border: none !important;
              font-family: AvantGarde-Bold;
            }
          }
          .v-select__slot {
            border: none;
            font-family: AvantGarde-Bold;
            // padding: 5px 12px;
            padding: 0;
            input {
              border: none;
              margin: 0;
            }
          }
        }
      }

      .error {
        border-color: red !important;

        &::placeholder {
          color: $alert-color !important;
          opacity: 1;
        }

        .v-input__slot {
          border-color: $alert-color;
        }

        .vti__input {
          border-color: red !important;
        }
      }

      .date-picker.error {
        input {
          border: 1px solid red;
        }
      }

      .upper {
        text-transform: uppercase;
      }

      span {
        color: black;
        font-size: 16px;
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      select {
        background-image: url("/img/sort-down.svg");
        background-size: 10px;
        background-position: right 10px center;
        background-repeat: no-repeat;
        // font-family: AvantGarde-Bold;
      }

      select option {
        font-size: 14pt;
      }

      .v-input__slot {
        margin: 0;
      }
    }

    #alergy {
      .v-text-field__details {
        display: none !important;
      }
    }

    #birthday {
      .error {
        input {
          border: 1px solid red;
        }
      }
      /*
                input {
                    border: 1px solid red;
                }
                */
    }

    #price {
      background-color: #ddd;
      padding: 20px;

      .row {
        width: 100%;
        margin: 5px 0;
        overflow: hidden;

        .name {
          font-size: 16px;
          b {
            text-transform: uppercase;
            font-weight: bold;
            font-family: Roboto-Bold;
          }
        }
        .clickable {
          font-size: 14px;
          margin-left: 10px;
        }
        .value {
          font-weight: bold;
          font-size: 20px;
          float: right;
        }

        &.total {
          border-top: 1px solid rgba(0, 0, 0, 0.5);
          padding-top: 10px;
          margin-top: 10px;
          font-family: Roboto-Bold;

          .name,
          .value {
            font-family: Roboto-Bold;
            // text-transform: uppercase;
            font-size: 24px;
          }
        }
      }
      h5,
      span {
        display: inline-block;
        height: 100%;
        margin: 0;
        padding: 0;
        vertical-align: middle;
      }

      h5 {
        margin-right: 20px;
      }

      span {
        font-weight: bold;
        // color: $main-color;
        font-size: 40px;
      }
    }

    #discounts-list {
      ul {
        li {
          list-style-type: circle;
        }
      }
    }

    .terms_and_conditions {
      margin: 0;
      display: inline-block;
    }

    .information {
      border: 1px solid $secondary-color;
      margin-left: 10px;
      padding: 10px;
    }

    #send {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: AvantGarde-Bold;
      margin-top: 5px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #000022;
      color: $secondary-color;

      &:hover {
        background-color: rgb(255, 70, 0) !important;
      }
    }
  }
}

@media (max-width: 720px) {
  #pga {
    .box {
      .item {
        width: calc(100% - 20px);
      }
    }
  }
}

@include media(">phone", "<tablet") {
  #pga {
    .box {
      .item {
        margin: 0 !important;
      }
    }
  }
}
</style>
